<div class="container py-3">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <div class="d-flex align-items-center">
      <h2 class="m-0">Dashboard</h2>
      <button class="btn btn-link btn-sm p-0 text-muted ms-2"
              type="button"
              (click)="openLiveConnectionHelp()"
              matTooltip="Live Connection">
        <span class="material-icons" style="font-size: 16px; vertical-align: middle;">info</span>
      </button>
    </div>
    <button class="btn btn-link btn-sm p-0 text-primary"
            (click)="openSettingsHelp()"
            matTooltip="How GeoAstra NTRIP Caster works">
      <span class="material-icons" aria-hidden="true">menu_book</span>
    </button>
  </div>


        <!-- NTRIP Connections Display Area (moved to top per request) -->
        <div class="subsection mt-2 dashboard-section dashboard-section-live">
          <div class="d-flex justify-content-between align-items-center mb-2 subheader dashboard-section-titlebar">
            <h4 class="m-0 subsection-title">My NTRIP Connections - Live</h4>
            <div class="d-flex align-items-center gap-2">
              <div class="text-muted small" *ngIf="lastConnectionsRefreshAt">
                Last updated: {{ lastConnectionsRefreshAt | date:'mediumTime' }}
              </div>
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="onRefreshConnectionsNow()" [disabled]="loadingConnections">
                <span class="material-icons" style="font-size: 18px; vertical-align: middle;">refresh</span>
              </button>
            </div>
          </div>
          <div class="row g-2 mb-2" *ngIf="!loadingConnections">
            <div class="col-6 col-md-3">
              <div class="metric-card">
                <div class="metric-label">Total</div>
                <div class="metric-value">{{ totalConnections }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="metric-card">
                <div class="metric-label">Bases</div>
                <div class="metric-value">{{ totalBaseConnections }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="metric-card">
                <div class="metric-label">Rovers</div>
                <div class="metric-value">{{ totalRoverConnections }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="metric-card">
                <div class="metric-label">MountPoints</div>
                <div class="metric-value">{{ totalMountpointsWithConnections }}</div>
              </div>
            </div>
          </div>
          <!-- Loading State -->
          <div *ngIf="loadingConnections" class="loading-state">
            <p>Loading connections...</p>
          </div>
          <!-- No Connections State -->
          <div *ngIf="!loadingConnections && userNtripConnections.length === 0" class="no-connections">
            <p>No active NTRIP connections found.</p>
          </div>
          <!-- Professional console-style list: per-mountpoint expandable cards -->
          <div *ngIf="!loadingConnections && processedGroups.length > 0" class="accordion-list">
            <div class="accordion-item" *ngFor="let g of processedGroups">
              <div class="accordion-header d-flex justify-content-between align-items-center"
                   (click)="toggleMpGroup(g.mpDisplay)">
                <div class="d-flex align-items-center gap-2">
                  <span class="mp-value">{{ g.mpDisplay }}</span>
                  <span class="badge bg-success-subtle text-success border">Base {{ g.countBase }}</span>
                  <span class="badge bg-primary-subtle text-primary border">Rovers {{ g.countRovers }}</span>
                </div>
                <div class="d-flex align-items-center gap-2 text-muted small">
                  <span class="material-icons" style="font-size:18px; vertical-align: middle;">
                    {{ isGroupExpanded(g.mpDisplay) ? 'expand_more' : 'chevron_right' }}
                  </span>
                </div>
              </div>
              <div class="accordion-body" *ngIf="isGroupExpanded(g.mpDisplay)">
                <div class="table-responsive border rounded">
                  <table class="table table-sm align-middle mb-0">
                    <thead class="table-light">
                      <tr>
                        <th style="width: 90px;">Type</th>
                        <th style="width: 140px;">Agent</th>
                        <th style="width: 160px;">IP Address</th>
                        <th style="width: 140px;">User</th>
                        <th style="width: 240px;">Connected For</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let r of g.rows">
                        <td>
                          <span class="badge"
                                [ngClass]="{ 'bg-success-subtle text-success border': r.displayType === 'base', 'bg-primary-subtle text-primary border': r.displayType !== 'base' }">
                            {{ r.displayType }}
                          </span>
                        </td>
                        <td>{{ r.agent }}</td>
                        <td class="font-mono">{{ r.ip }}</td>
                        <td>{{ r.user }}</td>
                        <td class="font-mono">{{ r.connectedFor }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mountpoint pager + selector row (PPK Downloader style) placed between the two subsections -->
        <!-- Move PPK-like pager/selector into the new subsection below -->
        <!-- removed from here -->
        

        <!-- spacing between top subsection and settings subsection -->
        <div class="row"><div class="col-12"><br></div></div>
        <div class="row"><div class="col-12"><br></div></div>
        <!-- Settings subtitle outside the subsection frame/card -->
        <div class="d-flex align-items-center justify-content-between mt-2">
          <div class="d-flex align-items-center">
            <h2 class="m-0">Settings You Need for Your RTK Base(s) and Rover(s)</h2>
            <button class="btn btn-link btn-sm p-0 text-muted ms-2"
                    type="button"
                    (click)="openConnectHelp()"
                    matTooltip="How to connect">
              <span class="material-icons" style="font-size: 16px; vertical-align: middle;">info</span>
            </button>
          </div>
        </div>
        <!-- New container subsection that wraps the rest components (excluding My NTRIP Connections - Live) -->
        <div class="subsection mt-2 dashboard-section dashboard-section-settings">
          <!-- Removed mountpoint pagination navigation bar per request -->
          <div class="col-12 mb-2" *ngIf="currentMountPoint as curMp">
            <div class="d-flex align-items-center">
              <span class="me-2 small text-muted">Select a MountPoint:</span>
              <span class="mp-select-wrapper" style="min-width: 280px;">
                <select class="form-select form-select-sm mp-select"
                        [ngModel]="currentMountPoint.stMountPoint || ''"
                        (ngModelChange)="selectFromDropdownName($event)">
                  <option value=""></option>
                  <option *ngFor="let mp of sortedMountPoints" [value]="mp.stMountPoint">{{ mp.stMountPoint }}</option>
                </select>
              </span>
              <span class="ms-3" [title]="isMountpointActive(curMp.stMountPoint) ? 'Online' : 'Offline'">
                (
                <span [ngStyle]="{ display: 'inline-block', width: '10px', height: '10px', 'border-radius': '50%', 'background-color': isMountpointActive(curMp.stMountPoint) ? '#22c55e' : '#9ca3af' }"></span>
                <span class="ms-1">{{ isMountpointActive(curMp.stMountPoint) ? 'Online' : 'Offline' }}</span>
                )
              </span>
            </div>
          </div>
          <div class="row g-3 align-items-start mb-2 mt-2">
            <div class="col-12 col-md-7">
              <!-- removed legacy selector subsection -->

              <!-- NTRIP Settings for RTK Base (stacked) -->
              <div class="subsection mt-2 ms-4">
                <div class="d-flex justify-content-between align-items-center mb-2 subheader">
                  <h4 class="m-0 subsection-title no-leading-bar">NTRIP Settings for RTK Base</h4>
                </div>
                <div>
                  <div><strong class="content-description">MountPoint:</strong> <span class="mp-value">{{ selectedMountPoint?.stMountPoint }}</span></div>
                  <div><strong class="content-description">NTrip Caster URL:</strong> <span class="mp-value">{{ ntripServer?.url }}</span></div>
                  <div><strong class="content-description">NTrip Caster Port:</strong> <span class="mp-value">{{ ntripServer?.port }}</span></div>
                  <div><strong class="content-description">UserName(Optional):</strong> <span class="mp-value">{{ selectedUser?.uUserName }}</span></div>
                  <div><strong class="content-description">Password:</strong> <span class="mp-value">{{ selectedUser?.uPassword }}</span></div>
                </div>
              </div>

              <!-- NTRIP Settings for RTK Rovers (stacked) -->
              <div class="subsection mt-2 ms-4">
                <div class="d-flex justify-content-between align-items-center mb-2 subheader">
                  <h4 class="m-0 subsection-title no-leading-bar">NTRIP Settings for RTK Rovers</h4>
                </div>
                <div>
                  <div><strong class="content-description">Mount Point:</strong> <span class="mp-value">{{ selectedMountPoint?.stMountPoint }}</span></div>
                  <div><strong class="content-description">NTrip Caster URL:</strong> <span class="mp-value">{{ ntripServer?.url }}</span></div>
                  <div><strong class="content-description">NTrip Caster Port:</strong> <span class="mp-value">{{ ntripServer?.port }}</span></div>
                  <div><strong class="content-description">UserName:</strong> <span class="mp-value">{{ selectedUser?.dUserName }}</span></div>
                  <div><strong class="content-description">Password:</strong> <span class="mp-value">{{ selectedUser?.dPassword }}</span></div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5 d-flex align-items-start">
              <img src="assets/images/landing/GeoAstra_NTRIP.png" alt="GeoAstra NTRIP Diagram" class="img-fluid w-100 rounded border diagram-scale-80 diagram-align-top">
            </div>
          </div>
        </div>

        <!-- Removed separate blocks; these sections are now stacked under the left column of the message box -->
</div>